import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

const PageLayout = ({
  children,
  backgroundGradient = "linear-gradient(135deg, #f8faf8 0%, #e6f4ea 100%)",
  showIntroduction = false,
  introTitle,
  introContent,
  introAlert
}) => {
  return (
    <Box sx={{ minHeight: '100vh', background: backgroundGradient }}>
      {children[0]} {/* Hero Section */}

      <Container maxWidth="lg" sx={{ py: 8 }}>
        {showIntroduction && (
          <Paper elevation={4} sx={{ p: 4, borderRadius: 4, mb: 6 }}>
            <Typography variant="h4" fontWeight={700} gutterBottom color="#1b5e20">
              {introTitle}
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
              {introContent}
            </Typography>
            {introAlert && introAlert}
          </Paper>
        )}

        {children.slice(1)} {/* Rest of the content */}
      </Container>
    </Box>
  );
};

export default PageLayout;
